import { createAction } from 'redux-act';

export const clearBooking = createAction('booking/CLEAR_BOOKING');
export const createBooking = createAction('booking/CREATE_BOOKING');
export const trackBooking = createAction('booking/TRACK_BOOKING');
export const fetchBooking = createAction('booking/FETCH_BOOKING');
export const fetchBookingFailure = createAction('booking/FETCH_BOOKING_FAILURE');
export const setBooking = createAction('booking/SET_BOOKING');
export const showNpsSurveyAfterBooking = createAction('booking/SHOW_NPS_SURVEY_AFTER_BOOKING');
